import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTrackingContext } from '../../context/trackingContext';
import Cookies from 'js-cookie';
import useClient from '../../hooks/useClient';
import config from '../../config';
import { useUserContext } from '../../context/userContext';

const Heading = ({ label, to, setExpanded, handleTabChange, onClick = () => {} }) => {
  const { trackClick } = useTrackingContext();

  const location = useLocation();
  return (
    <Link
      className="font-Korolev-Bold hover:text-black hover:bg-white w-fit pt-[6px] px-[10px]"
      to={to}
      onClick={
        location.pathname === to
          ? () => {
              trackClick({ btnName: 'sidebar' + label });
              setExpanded(false);
              handleTabChange();
            }
          : () => onClick()
      }>
      {label}
    </Link>
  );
};

const AuthHeader = ({ loggedIn, handleTabChange }) => {
  const { setUserData } = useUserContext();

  const [expanded, setExpanded] = useState(false);
  const genericHamburgerLine = `h-1 w-7 my-1 rounded-full bg-black transition ease transform duration-300 z-[2] ${
    loggedIn && 'bg-white'
  }`;
  const client = useClient();

  const removeCookie = async () => {
    await client.get(`${config.everywhereApi}/users/logout`);
    Cookies.remove('_barbToken');
    setUserData();
  };

  const navbarClassName = () => {
    if (loggedIn) {
      return expanded
        ? 'text-white bg-black transition h-full'
        : 'bg-loggedInMobileBg bg-black bg-opacity-90 bg-top bg-cover lg:bg-none';
    }

    return expanded
      ? 'text-white bg-black bg-opacity-90 transition h-full'
      : 'text-black bg-[white]';
  };

  return (
    <div
      className={`fixed lg:sticky top-0 left-0 right-0 pt-3 lg:pt-6 xl:pt-7 pl-4 lg:pl-6 xl:pl-10 pr-6 lg:pr-6 xl:pr-10 pb-3 lg:pb-6 xl:pb-10 z-[2000]  ${navbarClassName()}`}>
      <div
        className="flex flex-col h-12 w-12 justify-center items-center group "
        onClick={() => setExpanded(!expanded)}>
        <div
          className={`${genericHamburgerLine} ${
            expanded ? 'rotate-45 translate-y-3 bg-white' : ''
          }`}
        />
        <div className={`${genericHamburgerLine} ${expanded ? 'opacity-0 bg-white' : ''}`} />
        <div
          className={`${genericHamburgerLine} ${
            expanded ? '-rotate-45 -translate-y-3 bg-white' : ''
          }`}
        />
      </div>

      {expanded && (
        <div className="pt-12 h-1/3 text-white uppercase">
          <div className={`flex flex-col text-3xl gap-3`}>
            {!loggedIn ? (
              <>
                <Heading
                  label="Create Account"
                  to="/create-account"
                  setExpanded={setExpanded}
                  handleTabChange={() => {}}
                />
                <Heading
                  label="Log in"
                  to="/login"
                  setExpanded={setExpanded}
                  handleTabChange={() => {}}
                />
              </>
            ) : (
              <>
                <Heading
                  label="My Account"
                  to="/account"
                  setExpanded={setExpanded}
                  handleTabChange={() => handleTabChange(1, 'Account Information')}
                />
                <Heading
                  onClick={() => {
                    removeCookie();
                  }}
                  label="Sign out"
                  to="/login"
                  setExpanded={setExpanded}
                />
                <Heading
                  label="Account Information"
                  to="/account"
                  setExpanded={setExpanded}
                  handleTabChange={() => handleTabChange(1, 'Account Information')}
                />
                <Heading
                  label="Games & Launcher"
                  to="/account"
                  setExpanded={setExpanded}
                  handleTabChange={() => handleTabChange(2, 'Games & Launcher')}
                />
                <Heading
                  label="Password & Security"
                  to="/account"
                  setExpanded={setExpanded}
                  handleTabChange={() => handleTabChange(3, 'Password and Security')}
                />
                <Heading
                  label="Communication Preferences"
                  to="/account"
                  setExpanded={setExpanded}
                  handleTabChange={() => handleTabChange(4, 'Communication Preferences')}
                />
                {/* <Heading
                  label="Refer a Friend"
                  to="/account"
                  setExpanded={setExpanded}
                  handleTabChange={() => handleTabChange(5, 'Refer a Friend')}
                /> */}
              </>
            )}
            <Heading
              label="Build A Rocket Boy"
              to="https://www.buildarocketboy.com"
              setExpanded={setExpanded}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AuthHeader;
